var Opcion = /** @class */ (function () {
    function Opcion(boton, listener) {
        var _this = this;
        var _a;
        this.boton = boton;
        this.listener = listener;
        this.abierto = false;
        this.onClick = function () {
            var abierto = _this.abierto;
            _this.listener.onClick(_this);
            if (!abierto) {
                _this.expande();
            }
        };
        this.onKeyDown = function (e) {
            if (_this.listener.onKeyDown(_this, e.key)) {
                e.preventDefault();
            }
        };
        this.contrae = function () {
            _this.abierto = false;
            _this.contenedor.style.setProperty('--altura', String(0));
            _this.enlaces.forEach(function (x) { return x.tabIndex = -1; });
            _this.salir.tabIndex = -1;
        };
        this.expande = function () {
            _this.abierto = true;
            _this.contenedor.style.setProperty('--altura', _this.contenido.offsetHeight + 'px');
            _this.enlaces.forEach(function (x) { return x.tabIndex = 0; });
            _this.salir.tabIndex = 0;
        };
        this.focus = function () {
            _this.boton.tabIndex = 0;
            _this.boton.focus();
        };
        this.blur = function () {
            _this.boton.tabIndex = -1;
        };
        var padre = boton.parentNode;
        this.contenedor = padre === null || padre === void 0 ? void 0 : padre.nextElementSibling;
        var contenido = this.contenedor.querySelector('.inner');
        if (!contenido) {
            throw new Error('Falta el .inner del contenido');
        }
        this.salir = document.createElement('div');
        this.salir.tabIndex = -1;
        this.salir.addEventListener('focus', this.focus);
        (_a = contenido.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(this.salir);
        this.enlaces = [].slice.call(contenido.querySelectorAll('a'));
        this.contenido = contenido;
        this.boton.addEventListener('click', this.onClick);
        this.boton.addEventListener('keydown', this.onKeyDown);
    }
    return Opcion;
}());
var Acordeon = /** @class */ (function () {
    function Acordeon(contenedor) {
        var _this = this;
        this.onClick = function (opcion) {
            _this.opciones.forEach(function (x) { return x.contrae(); });
        };
        this.onKeyDown = function (opcion, key) {
            var indice = _this.opciones.indexOf(opcion);
            var boton = null;
            switch (key) {
                case 'ArrowDown':
                    boton = _this.opciones[indice + 1] || _this.opciones[0];
                    break;
                case 'ArrowUp':
                    boton = _this.opciones[indice - 1] || _this.opciones[_this.opciones.length - 1];
                    break;
                case 'PageUp':
                    boton = _this.opciones[Math.max(indice - 5, 0)];
                    break;
                case 'PageDown':
                    boton = _this.opciones[Math.min(indice + 5, _this.opciones.length - 1)];
                    break;
                case 'End':
                    boton = _this.opciones[_this.opciones.length - 1];
                    break;
                case 'Home':
                    boton = _this.opciones[0];
                    break;
            }
            if (boton) {
                opcion.blur();
                boton.focus();
                return true;
            }
            return false;
        };
        this.opciones = [].slice.call(contenedor.querySelectorAll('button'))
            .map(function (boton, i) {
            var opcion = new Opcion(boton, _this);
            opcion.contrae();
            if (i !== 0) {
                opcion.blur();
            }
            return opcion;
        });
    }
    return Acordeon;
}());
export default Acordeon;
